// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2YG_H","copyright":"Footer_copyright__37VIr"};